import Button from '@mui/material/Button';

import classes from './AcademyPrices.module.css';

const AcademyPrices = () => {
  return (
    <aside className={classes.academyPriceContainer}>
      <p className={classes.title}>Precios Academia</p>
      <div className={classes.priceInfo}>
        <aside className={classes.priceInfoDescription}>
          <p className={classes.priceText}>
            <strong>$35 USD al año</strong>
          </p>
          <p className={classes.priceText}>
            Cargo anual único por tu Academia.
          </p>
        </aside>
        <aside
          className={classes.priceInfoDescription}
          style={{
            borderLeft: '1px solid #d8d8d8',
            borderRight: '1px solid #d8d8d8'
          }}
        >
          <p className={classes.priceText}>
            <strong>$0.00 USD por curso</strong>
          </p>
          <p className={classes.priceText}>
            Publica los cursos que desees en tu Academia sin costo
            alguno.
          </p>
        </aside>
        <aside className={classes.priceInfoDescription}>
          <p className={classes.priceText} style={{ fontSize: 18 }}>
            <strong>$1.99 USD por inscripción</strong>
          </p>
          <p className={classes.priceText}>
            Cargo único por cada inscripción a cualquiera de los
            cursos en tu Academia.
          </p>
        </aside>
        <Button
          className={classes.createAcademyBtn}
          component="a"
          href={`${process.env.API_URL_PAGOS}/cart/checkout/createAcademy`}
        >
          Crear mi Academia
        </Button>
        <p style={{ textAlign: 'center', fontSize: 24 }}>
          <strong>Funcionalidad todo incluido:</strong>
        </p>
        <aside className={classes.priceListContainer}>
          <ul className={classes.priceList}>
            <li className={classes.priceItem}>
              Número ilimitado de cursos
            </li>
            <li className={classes.priceItem}>
              Número ilimitado de usuarios
            </li>
            <li className={classes.priceItem}>
              Número ilimitado de códigos de descuento y gratuidad
            </li>
            <li className={classes.priceItem}>
              Personaliza con tu imagen de marca
            </li>
          </ul>
        </aside>
        <aside className={classes.priceListContainer}>
          <ul className={classes.priceList}>
            <li className={classes.priceItem}>
              Emisión automatizada de Diplomas / Constancias por
              cursos terminados
            </li>
            <li className={classes.priceItem}>
              Estadísticas y control de usuarios
            </li>
            <li className={classes.priceItem}>
              Integración con Google Analytics
            </li>
          </ul>
        </aside>
        <p className={classes.complementaryPriceText}>
          Desde el panel de administración de tu Academia puedes
          configurar cada curso para ofrecerlo solo en tu Academia,
          solo en la EduStore, o en ambas al mismo tiempo.
        </p>
      </div>
      <figure className={classes.figureAcademy}>
        <img
          src="https://d1g6c01s9ssd7h.cloudfront.net/img/imagen_Academia.png"
          alt=""
          className={classes.img}
        />
      </figure>
    </aside>
  );
};

export default AcademyPrices;
